export const ENV =
  window.location.href.includes('dev') ||
  window.location.href.includes('localhost')
    ? '.dev'
    : '';

export const REACT_APP_SSO_URL = `https://auth${ENV}.doctoroncall.com.my`;
export const { REACT_APP_VKEY, REACT_APP_MERCHANT_ID } = process.env;
export const MARKETPLACE_CART_URL =
  ENV === '.dev'
    ? 'https://marketplace.dev.doctoroncall.com/cart'
    : 'https://www.doctoroncall.com/cart';
